import { render, staticRenderFns } from "./AreaGuides.vue?vue&type=template&id=c60c4344&scoped=true&"
import script from "./AreaGuides.vue?vue&type=script&lang=js&"
export * from "./AreaGuides.vue?vue&type=script&lang=js&"
import style0 from "./AreaGuides.vue?vue&type=style&index=0&id=c60c4344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c4344",
  null
  
)

export default component.exports